import { render, staticRenderFns } from "./BoxCreationButton.vue?vue&type=template&id=c63ba268&scoped=true&"
import script from "./BoxCreationButton.vue?vue&type=script&lang=js&"
export * from "./BoxCreationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63ba268",
  null
  
)

export default component.exports